import { Injectable } from '@angular/core';
import { FileManagerService } from './file-manager.service';
import { get } from 'lodash';
import { TableExportColumn, TableExportConfiguration } from '@app/shared/models/table.model';

@Injectable()
export class ExportTableService {
    private fileName: string;
    private columns: TableExportColumn[];

    constructor(private fileManagerService: FileManagerService) {}

    configure(configuration: TableExportConfiguration) {
        this.fileName = configuration.fileName;
        this.columns = configuration.columns;
    }

    export(source: unknown[]) {
        const data = source.map((element) => {
            const dataRow = {};
            this.columns.forEach((column) => {
                if (column.transformFn) {
                    dataRow[column.valueProp] = column.transformFn(get(element, column.valueProp));
                } else {
                    dataRow[column.valueProp] = get(element, column.valueProp, '');
                }
            });
            return dataRow;
        });

        this.fileManagerService.download(
            this.fileName,
            data,
            this.columns.map((column) => column.name)
        );
    }
}
